import { render, staticRenderFns } from "./stockProductListComponent.vue?vue&type=template&id=77e47112&scoped=true&"
import script from "./stockProductListComponent.vue?vue&type=script&lang=js&"
export * from "./stockProductListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e47112",
  null
  
)

export default component.exports